module.exports = __webpack_public_path__ + "static/media/genie3.dd130813.webm";